import React, { useEffect, useState } from "react";
import "./mobile_settings.css";
import * as Yup from "yup";
import CustomButton from "../../../components/CustomButton/custombutton";
import { Form, Formik } from "formik";
import CustomInput from "../../../components/CustomInput/CustomInput";
import api from "../../../api/api";
import apiUtil from "../../../api/apiUtil";
import getToken from "../../getToken";

const MobileSettings = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [data, setData] = useState([]);

  const changeActiveTabHandler = (newTab) => {
    setActiveTab(newTab);
    if (newTab === 2) {
      setParamSettingDetail({
        Name: "ReserveCancel",
      });
    } else if (newTab === 3) {
      setParamSettingDetail({
        Name: "AmountToPoint",
      });
    } else if (newTab === 4) {
      setParamSettingDetail({
        Name: "ExtraBedFees",
      });
    } else if (newTab === 5) {
      getAppVersionConfig();
    } else {
      setParamSettingDetail({
        Name: "MembershipDuration",
      });
    }
  };

  const [paramSettingDetail, setParamSettingDetail] = useState({
    Name: "MembershipDuration",
  });

  const getSettingDetailsByAdmin = (value = paramSettingDetail) => {
    api.get("Admin/GetSettingDetailByAdmin", value, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response.data.data);
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setData(response.data.data);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          setData([]);
          console.log(error);
        }
      )
    );
  };
  let brandId = localStorage.getItem("brandId");
  const onSubmitExpirationConfigHandler = (values, actions) => {
    const info = {
      id: "a1c60ff4-cdfc-11ed-b26e-6045bdd63acb",
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      brandId: brandId,
      name: "MembershipDuration",
      valueInText: "",
      valueInInt: values.membership_expire,
      valueInJson: null,
    };

    api.post("Admin/UpdateSettingByAdmin", info, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            alert("Member Experation saved successfully!!");
            getSettingDetailsByAdmin();
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });

    actions.setSumitting(false);
  };

  const onSubmitReservationConfigHandler = (values, actions) => {
    const info = {
      id: "d4e6bf43-cdfc-11ed-b26e-6045bdd63acb",
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      brandId: brandId,
      name: "ReserveCancel",
      valueInText: "",
      valueInInt: values.reservation_cancel_hour,
      valueInJson: null,
    };

    api.post("Admin/UpdateSettingByAdmin", info, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            alert("Reservation cancel hour saved successfully!!");
            getSettingDetailsByAdmin();
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });

    actions.setSumitting(false);
  };

  const onSubmitAmountConfigHandler = (values, actions) => {
    const info = {
      id: "00d2d215-2c98-4633-6a94-08db077d4f70",
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      brandId: brandId,
      name: "AmountToPoint",
      valueInText: "",
      valueInInt: values.amount,
      valueInJson: null,
    };

    api.post("Admin/UpdateSettingByAdmin", info, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            alert("Amount to point saved successfully!!");
            getSettingDetailsByAdmin();
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });

    actions.setSumitting(false);
  };

  const [appVersionDetail, setAppVersionDetail] = useState({});
  const getAppVersionConfig = () => {
    api
      .get("Admin/GetMemberAppSettingByAdmin", {}, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setAppVersionDetail(response.data.data);
            } else {
              alert(response.data.message);
            }
          },
          (error) => {
            console.log(error);
          }
        );
      });
  };

  const AppVersionConfigValidation = Yup.object().shape({
    versionNo: Yup.string()
      .test("app_verion_number", "Please enter decimal numbers only.", (val) =>
        /^(\d+\.)*\d+$/.test(val)
      )
      .required("Please enter app version number."),
    notiTitle: Yup.string().required(
      "Please enter version notification title."
    ),
    notiMsg: Yup.string().required(
      "Please enter version notification message."
    ),
    playstoreUrl: Yup.string().required("Please enter google play url."),
    iosUrl: Yup.string().required("Please enter app store url."),
  });

  const onSubmitVersionAppConfigHandler = (values, actions) => {
    const versionAppConfig = {
      isAdmin: false,
      ...values,
    };

    api
      .post("Admin/UpdateAppSetting", versionAppConfig, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              alert("Mobile setting saved successfully!!");
              getAppVersionConfig();
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    actions.setSumitting(false);
  };

  const onSubmitExtraBedFeesConfigHandler = (values, actions) => {
    const info = {
      id: "4123dba6-4c1e-4a56-86d3-fb27a83e5a13",
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      brandId: brandId,
      name: "ExtraBedFees",
      valueInText: "",
      valueInInt: values.fees,
      valueInJson: null,
    };

    api.post("Admin/UpdateSettingByAdmin", info, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            alert("Extra Bed Fees saved successfully!!");
            getSettingDetailsByAdmin();
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });

    actions.setSumitting(false);
  };

  useEffect(() => {
    getSettingDetailsByAdmin();
  }, [paramSettingDetail]);

  return (
    <div className="mobile-settings">
      <div className="menuBtnList">
        <CustomButton
          text="Membership Expiration"
          addIcon={false}
          className={`btnMenu ${activeTab === 1 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(1)}
        />
        <CustomButton
          text="Reservation Cancel Hour Limit"
          addIcon={false}
          className={`btnMenu ${activeTab === 2 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(2)}
        />
        <CustomButton
          text="Amount to Point"
          addIcon={false}
          className={`btnMenu ${activeTab === 3 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(3)}
        />
        <CustomButton
          text="Extra Bed Fees"
          addIcon={false}
          className={`btnMenu ${activeTab === 4 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(4)}
        />
        <CustomButton
          text="App Version"
          addIcon={false}
          className={`btnMenu ${activeTab === 5 ? "active" : ""}`}
          onClick={() => changeActiveTabHandler(5)}
        />
      </div>

      {activeTab === 1 && (
        <div className="mobile-settings-container">
          <h4 className=" title_text mt-2">
            Membership Expiration Configuration
          </h4>
          <Formik
            initialValues={{
              membership_expire: data.valueInInt ? data.valueInInt : "",
            }}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              membership_expire: Yup.string()
                .required("Please enter expried year of membership.")
                .test("membership_expire", "Please enter only number", (val) =>
                  /^\d+$/.test(val)
                ),
            })}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
              onSubmitExpirationConfigHandler(values, actions);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className="row">
                <div className="col-12 mt-2">
                  <CustomInput
                    name="membership_expire"
                    type="number"
                    label="Membership Expire (day)"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button type="button" className="button btnCancel">
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}

      {activeTab === 2 && (
        <div className="mobile-settings-container">
          <h4 className=" title_text mt-2">
            Reservation Cancel Hour Limit Configuration
          </h4>
          <Formik
            initialValues={{
              reservation_cancel_hour: data.valueInInt ? data.valueInInt : "",
            }}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              reservation_cancel_hour: Yup.string()
                .required("Please enter day of cancelled reservation.")
                .test(
                  "reservation_cancel_hour",
                  "Please enter only number",
                  (val) => /^\d+$/.test(val)
                ),
            })}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
              onSubmitReservationConfigHandler(values, actions);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className="row">
                <div className="col-12 mt-2">
                  <CustomInput
                    name="reservation_cancel_hour"
                    type="number"
                    label="Reservation Cancel (Hour Before)"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button type="button" className="button btnCancel">
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}

      {activeTab === 3 && (
        <div className="mobile-settings-container">
          <h4 className=" title_text mt-2">Amount to Point Configuration</h4>
          <Formik
            initialValues={{
              amount: data.valueInInt ? data.valueInInt : "",
            }}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              amount: Yup.string()
                .required("Please enter the amount.")
                .test("amount", "Please enter only number", (val) =>
                  /^\d+$/.test(val)
                ),
            })}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
              onSubmitAmountConfigHandler(values, actions);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className="row">
                <div className="col-12 mt-2">
                  <CustomInput
                    name="amount"
                    type="number"
                    label="Amount (1Point)"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button type="button" className="button btnCancel">
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}

      {activeTab === 4 && (
        <div className="mobile-settings-container">
          <h4 className=" title_text mt-2">Extra Bed Fees Configuration</h4>
          <Formik
            initialValues={{
              fees: data.valueInInt ? data.valueInInt : "",
            }}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              fees: Yup.string()
                .required("Please enter the fees.")
                .test("amount", "Please enter only number", (val) =>
                  /^\d+$/.test(val)
                ),
            })}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
              onSubmitExtraBedFeesConfigHandler(values, actions);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className="row">
                <div className="col-12 mt-2">
                  <CustomInput
                    name="fees"
                    type="number"
                    label="Fees"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button type="button" className="button btnCancel">
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}

      {activeTab === 5 && (
        <div className="mobile-settings-container">
          <h4 className=" title_text mt-2">Member App Version Configuration</h4>
          <Formik
            initialValues={{
              versionNo: appVersionDetail.versionNo
                ? appVersionDetail.versionNo
                : "",
              notiTitle: appVersionDetail.notiTitle
                ? appVersionDetail.notiTitle
                : "",
              notiMsg: appVersionDetail.notiMsg ? appVersionDetail.notiMsg : "",
              playstoreUrl: appVersionDetail.playstoreUrl
                ? appVersionDetail.playstoreUrl
                : "",
              iosUrl: appVersionDetail.iosUrl ? appVersionDetail.iosUrl : "",
            }}
            enableReinitialize={true}
            validationSchema={AppVersionConfigValidation}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
              onSubmitVersionAppConfigHandler(values, actions);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className="row">
                <div className="col-12 mt-2">
                  <CustomInput
                    name="versionNo"
                    type="text"
                    label="App Version Number"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="notiTitle"
                    type="text"
                    label="Version Notification Title"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="notiMsg"
                    label="Version Notification Message"
                    textarea="true"
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="playstoreUrl"
                    type="text"
                    label="Google Play URL"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomInput
                    name="iosUrl"
                    type="text"
                    label="App Store URL"
                    customclass="input_wrapper"
                    hideicon="true"
                  />
                </div>
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button type="button" className="button btnCancel">
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      )}
    </div>
  );
};

export default MobileSettings;
